import * as $ from 'jquery';


import { IDAL, IUser, IUserLocation } from './../services/IDAL';
import { 
    ICalendarEvents,
    ITranscribeService 
} from '../components/models/models';

class ElectronAdapter implements IDAL {
    public addDefaultQuestions(courseId: any) {
        return Promise.resolve();
    }
    
    public getLiveProjectUserLocations(): Promise<IUserLocation[]> {
        return Promise.resolve([]);
    }
    
    public getCourseAuthors(courseId: number): Promise<IUser[]> {
        return Promise.resolve([]);
    }

    public getCourseMentors(courseId: number): Promise<IUser[]> {
        return Promise.resolve([]);
    }

    public updateAuthorMentorDetails(userId: number, description: string, avatarUrl: string): Promise<void> {
        return Promise.resolve();
    }

    public uploadAvatarImage(imageBase64Content: string, imageName: string, isStaffUpload?: boolean, userId?: any): Promise<string> {
        return Promise.resolve("");
    }

    public locationGeocode(address: string): Promise<string> {
        return Promise.resolve("");
    }

    public getNumberOfLPUsers(courseId: any): Promise<string>{
        return Promise.resolve("");
    }

    public getLpAnalytics(courseId: any): Promise<string>{
        return Promise.resolve("");
    }

    public getOnlineUsers(): Promise<string>{
        return Promise.resolve("");
    }

    public submitExerciseResult(exerciseGroupId: number, exerciseResult: string): Promise<string>{
        return Promise.resolve("");
    }

    public submitCertificateTest(moduleId: number, usedExerciseIds: number[], certificateTestSubmission: string, finalResult: any, exercisesSolved: string): Promise<string>{
        return Promise.resolve("");
    }
    
    public getCertificateTestResults(courseId: number): Promise<string>{
        return Promise.resolve("");
    }
    
    public getMentorSettings(): Promise<string>{
        return Promise.resolve("");
    }

    public saveMentorSettings(receiveImmediateEmails: boolean): Promise<string>{
        return Promise.resolve("");
    }

    public getSisterLicenses(courseId: number): Promise<string>{
        return Promise.resolve("");
    }

    public getUsersSisterLicenses(forced:boolean = false): Promise<string>{
        return Promise.resolve("");
    }

    public startSisterLicenses(courseId: number): Promise<string>{
        return Promise.resolve("");
    }

    public startSisterLicensesAlt(courseId: number): Promise<string>{
        return Promise.resolve("");
    }

    public resetSisterLicense(userId: number, courseId: number): Promise<string>{
        return Promise.resolve("");
    }

    public userCanStartCertificateTest(courseId: number): Promise<string>{ 
        return Promise.resolve("");
    }

    public getSkillDomains(): Promise<string> {
        return Promise.resolve("");
    }

    public listAllCourses(course_type?: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public generateGroupsForSection(courseManningId: number, sessionId: number): Promise<void> {
        return Promise.resolve();
    }

    public addReviewers(course_id: number, reviewers: string[], group_id?: number): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public listAvailableCourses(course_type?: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public listOwnedCourses(course_type?: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public getCourseStructure(courseId: string, userRoles: string[]): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public getCourseProgressV2(courseId: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public getDetailsForCourseFull(courseId: string, unitIdex: string, moduleIndex: string, userRole: string, groupId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public getDetailsForCourseFullCached(courseId: string, unitIdex: string, moduleIndex: string, userRole: string, groupId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public getModuleDuration(courseId: any, unitIdex: any, moduleIndex: any): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve("");
        });
    }

    public extractModuleDurationsForCourse(JSONquery: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public reloadFullCourseDownloadFile(JSONquery: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public getBestsellers(numberOfBestSellers?: number): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve("");
        });
    }

    public invalidateCourse(JSONquery: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public updateFiles(JSONquery: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public updateExercisesForCurrentModuleFromJSON(courseId: string, unitId: string, moduleId: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public getNewS3Folders(): Promise<any> {
        return new Promise((resolve, reject) => {
            /*return Utils.readFile(`content/${bookName}/book.json`)
                        .then(fileContent => {
                            resolve(BookUtils.convertToBookContent(
                                JSON.parse(fileContent),
                                bookElementName,
                                this.getBookElementAudioLocation(bookName, bookElementName),
                                this.getBookElementSubtitlesLocation(bookName, bookElementName),
                                this.getBookElementContent(bookName, bookElementName))
                            );
                        }).catch(e => reject(e));*/
        });
    }

    public getDetailsForS3Course(folderName: string, createMissingVtts: boolean): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    public setMetadataForVtt(folderName: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public deleteCourse(courseId: any): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public editCourse(JSONquery: string): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    public createNewCourseV3(name: string, createOnMarketplace: boolean, is_hybrid: boolean, publisher: string, is_mini_lv: boolean, is_from_s3: boolean, s3_path?: string, course_type?: string): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve("");
        });
    }

    public listImagesFromS3(courseName: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public listScreenshotsFromS3(courseName: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public uploadImageToS3(imageName: string, courseName: string, image: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    createVideoScreenshotOnS3(video_src: string, courseName: string, unit_index: string, module_index: string, timestamp: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public updateModule(jsonQuery: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    /*public executeTryItYourselfCode(code: string, newCodeCSS:string, newCodeHTML:string, language: string, lambdaName: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let result="";
            resolve(result);
        });
    }*/

    public getCodeListingProgrammingLanguages(): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    /*public getTryItYourselfProgrammingLanguages(): Promise<any> {
        return new Promise((resolve, reject) => {
            let result="";
            resolve(result);
        });
    }*/

    public getAllVersions(module_id: string, unit_id: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public getDetailsForModuleVersion(module_id: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public restoreToVersion(current_module_id: string, unit_id: string, restore_to_module_id: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public loginUA(username, password): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public logoutUA(): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public updateUserProgress(jsonQuery: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public getAllAdmins(): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public getAllMentors(): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public deleteDeveloperUnscrabmlings(): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public getAllEditors(): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public getAllSpecialUsers(course_type?: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public getAllCoursesAndAuthors(course_type?: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public getAllCoursesAndMentors(course_type?: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public getNumberOfAvailableTokens(): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve("");
        });
    }

    public removeAuthorFromCourse(userId: string, courseId: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public removeMentorFromCourse(userId: string, courseId: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public getRoleForUser(jsonQuery: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public userIsLoggedIn(): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public getUserDetails(): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public setUserProgressSync(queryJSON: string) {

    }

    public setUserProgressAsync(queryJSON: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public getUserProgress(queryJSON: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public getUserProgressForWholeCourse(courseId: any): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public getUserDetailsByEmail(email): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve("");
        });
    }

    public hasAnyProgress(): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public userHasAccessForCourse(courseId: any): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public getUserSettings(): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public getFeedbackStatus(): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public setFeedbackStatus(newStatus: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public saveUserSettings(higlightWholeParagraph: boolean, higlightDisabled: boolean, higlightCurrentPhrase: boolean, pause_on_code_listings: boolean, pause_on_try_it_yourselfs: boolean, pause_on_exercises: boolean, autoplay: boolean, autocontinue: boolean, discussions_code_of_conduct_shown: boolean, discussions_email_notifications_offered: boolean, discussions_offered: boolean): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public sendFeedback(subject: string, email: string, feedback: string, platform: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public requestSupport(subject: string, email: string, feedback: string, platform: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public getExerciseGroup(id: any): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public unscrambleParagraph(courseId: any, unitIndex: any, moduleIndex: any, paragraphIndex: any, pret: boolean): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve("");
        });
    }

    public unscrambleModule(courseId: any, unitIndex: any, moduleIndex: any): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve("");
        });
    }

    public unscrambleUnit(courseId: any, unitIndex: any): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve("");
        });
    }

    public getVtt(courseId: any, unitIndex: any, moduleIndex: any): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve("");
        });
    }

    public getModuleContent(courseId: any, unitIndex: any, moduleIndex: any): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve("");
        });
    }

    public getAuthoredCourses(): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public getMentoredCourses(): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public search(bookShortName: string, query: string): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve("");
        });
    }

    public getAllSearchCategories(): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve("");
        });
    }

    public uploadExerciseImage(base64image: string, imageName: string, externalId: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let result = "";
            resolve(result);
        });
    }

    public getSlugs(id?: any): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve("");
        });
    }

    public createScaffoldCourse(coursename: string, createOnMarketplace: boolean): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    public transcribe(course_id: number, transcript_service: ITranscribeService, unit_index?: number, module_index?: number): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    public getTranscriptionsForCourse(courseId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    public ecommerceHealthCheck(): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    public getTocElementPrices(course_id: number): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    public getUnlockedStatusForTocElements(course_id: number): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    public getElementPrices(course_id: number, unit_index: number, module_index?: number): Promise<boolean> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    public getTokenProductOffering(): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    public cashout(): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    public getCashoutInfo(): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    public getParagraphPrices(course_id: number, unit_id: number, module_id: number): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    public saveNotificationPreferences(accept: boolean): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    public getTokenLedger(): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    public createParagraphBreaksForCourse(course_id: number): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    public saveStartEndDateForGroup(start_time: string, end_time: string, group_id: number): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    /*public saveLanguageForGroup(language: string, group_id: number): Promise<any>  {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }*/

    public assignMentorsToGroup(group_id: number, emails: string[], user_ids: number[]): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    public removeMentorFromGroup(group_id: number, email: string, user_id: number): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    public assignUsersToGroup(group_id: number, emails: string[], user_ids: string[]): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    public removeUserFromGroup(group_id: number, email: string, user_id: number): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    public getLicensedUsersForCourse(course_id: number): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    public getLicenseTier(group_id: number): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    public getSessions(course_id: number): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    public deleteGroup(course_id: number, group_id: number): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    public createNewGroup(course_id: number, sessionStartDate: string, sessionId: number, is_premium: boolean, name: string, start_time?: string): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    public createNewGroupByUser(course_id: number, sessionStartDate: string, sessionId: number, name: string, is_premium: boolean): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    public getLogForCourse(course_id: number): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    public getGroupsForCourse(course_id: string): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    public assignRoleToUser(username: string, role: string, course_id?: number): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    public deleteRoleForUser(username: string, role: string, course_id?: number): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    public setDeliverableDate(group_id: number, module_id: number, deliverable_date: string): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    public submitSubmission(group_id: number, module_id: number, course_id: number, sessionId: number, github_url: string): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    public getDeliverableDetails(module_id: number, course_id: number, group_id: number): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    public getGroupsForUser(course_id: any): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    public setSubmissionStatus(submission_id: any, submission_accepted: boolean): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }
    
    public addCertificationFeedbackMessage(group_id: any, feedback_message: string, is_mentor: boolean, mentor_id:any, user_id: any): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    public getCertificationFeedbackMessagesForUserAndGroup(group_id: any, user_id: any): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    public getMentorUIUserData(group_id: any): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    public getUserSubmissions(groupId: any, onlyCurrentUser: boolean, fullDetails?: boolean, moduleId?: any): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    public getUserInfo(): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    public setUserInfo(name?: string, listWeekdayTimes?: any, listWeekendTimes?: any, userInfo?: string, shareSkillLevel?: boolean, shareHours?: boolean, shareLocation?: boolean, skillLevels?: { id: number, level: number }[], selectedSkillDomains?: number[], languages?: string[], location?: string, locationText?: string, avatarUrl?: string, displayName?: string): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    public getAvailableGroupsForCourse(courseId: any): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    public joinGroup(group_id: number): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    public leaveGroup(group_id: number): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    lockGroup(group_id: number, lock: boolean): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    public getUserLocation(): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    public enrollCourse(courseId: any): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    setIsPremiumGroup(is_premium: boolean, group_id: number): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }
    setForceDeliverableDates(is_forced: boolean, group_id: number): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    clearLiveProjectOwnership(user_id: number, course_id: number): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    uploadFiles(formData: FormData): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    deleteFile(key: string): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    checkForNewLPLicenses(): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    getEvents(courseId: number, groupId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    setEvents(courseId: number, groupId: number, events: ICalendarEvents[]): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    generateViewEvent(productId: number, sisterLicenseId: number, associatedLicenseId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    generateLivebookViewerViewEvent(productId: number, livebookViewerProductId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    getRecentActivityLog(groupId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    getUpcomingEvents(groupId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    getUserCertificate(courseId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    getGroupMemberData(groupId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    obtainLiveBookCatalog(): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    cloneCourse(courseId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }
}

class Utils {
    private static root = "electron/"

    /* public static readFile(localFilePath: string): Promise<any> {
         return new Promise((resolve, reject) => {
             fs.readFile(this.getAbsolutePath(localFilePath), "utf-8", function (err, data) {
                 if (err) { reject(err); }
                 resolve(data);
             });
         });
     }
 
     public static readFileSync(localFilePath: string): string {
         return fs.readFileSync(this.getAbsolutePath(localFilePath), "utf-8");
     }
 
     public static writeFileSync(localFilePath: string, content: string) {
         fs.writeFileSync(this.getAbsolutePath(localFilePath), content, { encoding: "utf-8" });
     }
 
     public static getAbsolutePath(relativePath: string) {
         return `${this.root}${relativePath}`;
     }
 
     public static getFolderSubfolders(localFolderPath: string): string[] {
         const children: any = fs.readdirSync(this.getAbsolutePath(localFolderPath)); //Added :any
         return children.filter(child => !child.startsWith(".")).map(child => localFolderPath + child);
     }*/
}

if (window) {
    //(<any> window).electron = new ElectronAdapter();
    $("#manning-site-link").click(function (e) {
        if (e != null) e.preventDefault();
        //this is in eval bacause typescript complains :/
        eval(`require('electron').shell.openExternal('https://www.manning.com/')`);
        return false;
    });
}

export default ElectronAdapter;